
import React, { Component } from 'react';
import { Box } from 'reactjs-admin-lte'
import { Pagination, Form, FormGroup, Button } from 'react-bootstrap'
import { momentHelper } from '../helpers'
import SelectDate from 'component/element/SelectDate'
import Select from 'react-select'
import PrintButtons from 'component/element/PrintButtons'
import ReportStore from 'stores/ReportStore'
import XLSX from 'xlsx'
import FileSaver from 'file-saver'
import FontAwesome from 'react-fontawesome'
import DatePicker from 'component/element/DatePicker'
import IframeModal from 'component/element/IframeModal'
import Moment from 'moment'
import '../report.css'
// import { connect } from 'react-redux';
const WHOLE_YEAR = momentHelper.getMonth() //'00'
class ReportAccountReceiable extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loading:false,
      activePage:1,
      opt:'all',
      optList:[{label:'ทั้งหมด',value:'all'},{label:'เจ้าของรถ(บุคคล)',value:'person'},{label:'เจ้าของ(บริษัท)',value:'company'},{label:'บริษัทประกัน',value:'insurer'}],
      month:WHOLE_YEAR,
      year:momentHelper.getYear(),  
      data:[],
      dataDetail:[],
      isRange:false,
      day:momentHelper.getDay(),
      dayRange:momentHelper.getDay(),
      monthRange:WHOLE_YEAR,
      yearRange:momentHelper.getYear(),
      showDetail:false,
      isSubMenu:false,
      subMenu:[],
      type:''
    }
    this.refTableId = 'ReportAccountReceiable-'+Math.ceil(Math.random()*100);
    this.refTableDetailId = 'ReportAccountReceiableDetail-'+Math.ceil(Math.random()*100);
  }

  componentDidMount(){
   
  }

  componentWillReceiveProps(newProps){
    if(newProps.show && newProps.show!==this.props.show){
      this.loadData(this.state.year,this.state.month,this.state.day,this.state.opt)
    }
  }

  getAllDayOfMonth(date) {
    const all_day = Moment(date, "YYYY-MM").daysInMonth()
    if (all_day) {
      if (all_day<this.state.day) {
        var defaultDay = '00'
      } else {
        var defaultDay = this.state.day
      }
    } else {
      var defaultDay = '00'
    }
    return defaultDay
}

  getSummary() {
    let sum = 0
    let {dataDetail} = this.state
    dataDetail.forEach((item,index)=>{
      sum += (item.amount)*1
    })
    return sum
  }

  getSummaryAmount(field) {
        let {data} = this.state
        let total = 0
        data.forEach((item,index)=> {
            total += (item[field]===''||item[field]===null||item[field]===undefined||isNaN(item[field])?0:item[field]*1)
        }) 
        return total
  }

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  loadData(year='',month='',day='',opt='') {
    this.setState({loading:true,isRange:false,dayRange:momentHelper.getDay(),monthRange:month,yearRange:year})
    ReportStore.loadReportAccountReceivable(year,month,day,opt,(result)=>{
      this.setState({loading:false,data:result.data})
    })
  }

  loadDataRange(start='',end='',opt='') {
    ReportStore.loadReportAccountReceivableRange(start,end,opt,(result)=>{
      this.setState({loading:false,data:result.data})
    })
  }

  onTableDetailCloseClick() {
    this.setState({subMenu:[],isSubMenu:false,type:'',showDetail:false,dataDetail:[]},()=>{
      if (this.props.onUpdateEventKey!=undefined)
        this.props.onUpdateEventKey(undefined)
    })
  }

  onRowClick(item,type) {
    let {year,month,day,opt} = this.state
    this.setState({loading:true,type:type,subMenu:[{title:'ลูกค้า '+(opt=='all'?'ทั้งหมด ':opt=='person'?'เจ้าของรถ(บุคคล) ':opt=='company'?'เจ้าของรถ(บริษัท) ':opt=='insurer'?'เจ้าของ(บริษัท) ':'')+'ประเภท '+(type=='wait_finance'?'ยอดรวมค้างตั้งเบิก':type=='wait_payment'?'ยอดรวมค้างรับ':''),key:'s'+0}],isSubMenu:true},()=>{
        if (this.props.onUpdateEventKey!=undefined)
            this.props.onUpdateEventKey('s'+0)
    })
    ReportStore.loadReportAccountReceivableDetail(year,month,day,opt,type,(result)=>{
        this.setState({loading:false,dataDetail:result.data,showDetail:true})
    })
  }

  renderBody() {
    let {data} = this.state
    if (data.length==0) {
      return(<tr><td colSpan={6}>ไม่พบข้อมูล</td></tr>)
    } else {
      return(
        data.map((item,index)=>
            <tr key={index}>
              <td className='text-left'>{item.customer_name}</td>
              <td className='text-center'>{item.wait_finance_count}</td>
              <td className='text-right'><Button onClick={this.onRowClick.bind(this,item,'wait_finance')} bsClass='default' bsSize='xs'><FontAwesome name='search' /></Button> {this.getNumberFormat(item.wait_finance_amount)}</td>
              <td className='text-center'>{item.wait_payment_count}</td>
              <td className='text-right'><Button onClick={this.onRowClick.bind(this,item,'wait_payment')} bsClass='default' bsSize='xs'><FontAwesome name='search' /></Button> {this.getNumberFormat(item.wait_payment_amount)}</td>
              <td className='text-right'>{this.getNumberFormat(item.total_amount)}</td>
            </tr>
        )
      )
    }
  }

  renderBodyDetail() {
    let {dataDetail} = this.state
    if (dataDetail.length==0) {
      return(<tr><td colSpan={7}>ไม่พบข้อมูล</td></tr>)
    } else {
        return(
            dataDetail.map((item,index)=>{
                return(
                    <tr key={index}>
                        <td className='text-center'>{index+1}</td>
                        <td className='text-center'>{item.work_no}</td>
                        <td className='text-center'>{item.work_date}</td>
                        <td className='text-center'>{item.car_registration_no}</td>                        
                        <td className='text-center'>{item.brand}</td>
                        <td className='text-center'>{item.model}</td>
                        <td className='text-right'>{this.getNumberFormat(item.amount)}</td>
                    </tr>
                )
            })
        )    
    }
  }

  getDate() {
    let {day,year,month,isRange,dayRange,monthRange,yearRange} = this.state
    if (isRange) {
      let start = (day<10?'0'+day:day)+'/'+(month=='00'?'1':month)+'/'+year
      let end = dayRange+'/'+(monthRange<10?'0'+monthRange:monthRange)+'/'+yearRange
      return 'ประจำวันที่ '+start+' - '+end
    } else {
      let text = 'ประจำวันที่ '
      text += day+' '+momentHelper.getMonthText(month)+' '+year
      if (year==='0'||year==='00'||year===0) {
        text = 'ทั้งหมด'
      } else if (month==='0'||month==='00'||month===0) {
        text = 'ประจำปี '+year
      } else if (day==='0'||day==='00'||day===0) {
        text = 'ประจำเดือน '+momentHelper.getMonthText(month)+' '+year
      }
      return text
    }  
  }

  renderTable() {
      return(
        <div className='display-overflow'>
          <table id={this.refTableId} className='table table-responsive table-bordered-solid table-hover' style={{minWidth:'1280px'}}>
            <thead>
                <tr>
                  <th style={{display:'none'}} className='text-center' colSpan={6}>รายงานงวดตั้งเบิกค้างรับ {this.getDate()}</th>
                </tr>
                <tr>
                    <th rowSpan={2} className='text-center' style={{width:'250px'}}>ลูกค้า/ประกัน</th>
                    <th colSpan={2} className='text-center'>ยอดรวมค้างตั้งเบิก</th>
                    <th colSpan={2} className='text-center'>ยอดรวมค้างรับ</th>
                    <th rowSpan={2} className='text-center' style={{width:'110px'}}>รวมยอดค้าง</th>
                </tr>
                <tr>
                    <th className='text-center' style={{width:'70px'}}>จ็อบ</th>
                    <th className='text-center' style={{width:'90px'}}>จำนวนเงิน</th>
                    <th className='text-center' style={{width:'70px'}}>จ็อบ</th>
                    <th className='text-center' style={{width:'90px'}}>จำนวนเงิน</th>
                </tr>
            </thead>
            <tbody>
                {this.renderBody()}
            </tbody>
            <tfoot>
              <tr>
                <th className='text-right'>ยอดรวมสุทธิ</th>
                <th className='text-center'>{this.getSummaryAmount('wait_finance_count')}</th>
                <th className='text-right'>{this.getNumberFormat(this.getSummaryAmount('wait_finance_amount'))}</th>
                <th className='text-center'>{this.getSummaryAmount('wait_payment_count')}</th>
                <th className='text-right'>{this.getNumberFormat(this.getSummaryAmount('wait_payment_amount'))}</th>
                <th className='text-right'>{this.getNumberFormat(this.getSummaryAmount('total_amount'))}</th>
              </tr>
            </tfoot>
          </table>
        </div>
      )
  }

  renderTableDetail() {
    let {opt,type} = this.state
    return (
      <div className='display-overflow'>
        <table id={this.refTableDetailId} className='table table-responsive table-bordered-solid table-hover'>
          <thead>
            <tr style={{display:'none'}}>
              <th colSpan={3}>ลูกค้า : {opt=='all'?'ทั้งหมด ':opt=='person'?'เจ้าของรถ(บุคคล) ':opt=='company'?'เจ้าของรถ(บริษัท) ':opt=='insurer'?'เจ้าของ(บริษัท) ':''}</th>
              <th colSpan={3}>ประเภท : {type=='wait_finance'?'ยอดรวมค้างตั้งเบิก':type=='wait_payment'?'ยอดรวมค้างรับ':''}</th>
              <th></th>
            </tr>
            <tr>
              <th className='text-center' style={{width:'50px'}}>ลำดับ</th>
              <th className='text-center' style={{width:'100px'}}>หมายเลขใบงาน</th>
              <th className='text-center' style={{width:'120px'}}>วันที่</th>
              <th className='text-center' style={{width:'120px'}}>เลขทะเบียน</th>
              <th className='text-center' style={{width:'100px'}}>ยี่ห้อ</th>
              <th className='text-center' style={{width:'100px'}}>รุ่น</th>
              <th className='text-center' style={{width:'100px'}}>มูลค่า</th>
            </tr>
          </thead>
          <tbody>
            {this.renderBodyDetail()}
          </tbody>
          <tfoot>
            <tr>
              <th colSpan={6} className='text-right'>รวมทั้งสิ้น</th>
              <th className='text-right'>{this.getNumberFormat(this.getSummary())}</th>
            </tr>
          </tfoot>
        </table>
      </div>
    )
  }

  onPageSelect(eventKey) {
    this.setState({
      activePage: eventKey
    })
    // next... load new page
  }

  onDayChange(val){
    this.setState({
      day: val.value, isRange:false
    })
    this.loadData(this.state.year,this.state.month,val.value,this.state.opt)
  }

  onMonthChange(val) {
    let date = this.state.year-543+'-'+val.value
    let _day = '00'
    _day = this.getAllDayOfMonth(date)
    this.setState({
      month: val.value, isRange: false, day:_day
    })
    this.loadData(this.state.year,val.value,_day,this.state.opt)
  }

  onYearChange(val) {
    let date = val.value-543+'-'+this.state.month
    let _day = '00'
    _day = this.getAllDayOfMonth(date)
    this.setState({
      year: val.value, isRange: false, day:_day
    })
    this.loadData(val.value,this.state.month,_day,this.state.opt)
  }

  onOptChange(val) {
    this.setState({
      opt: val.value, isRange: false
    })
    this.loadData(this.state.year,this.state.month,this.state.day,val.value)
  }

  onExportExcel(e) {
    const worksheet = XLSX.utils.table_to_book(document.getElementById(this.refTableId));
    let wbout = XLSX.write(worksheet, { bookType: 'xlsx', bookSST: true, type: 'binary' });

    function s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
      return buf;
    }    
    const fileName = 'รายงานงวดตั้งเบิกค้างรับ.xlsx'
    FileSaver.saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), fileName) 
    this.setState({showExport:false})
  }

  onPrintTable(e) {
    const {isRange} = this.state
    let url = ''
    let param = 'PrintReportAccountReceiable&year='+this.state.year+'&month='+this.state.month+'&day='+this.state.day+'&customerType='+this.state.opt+'&isRange=false'
    if (isRange) {
        let {day,month,year,dayRange,monthRange,yearRange} = this.state
        let start = day+'/'+(month=='00'?'1':month)+'/'+(year-543)
        let end = dayRange+'/'+monthRange+'/'+(yearRange-543)
        param = 'PrintReportAccountReceiable&start_date='+start+'&end_date='+end+'&customerType='+this.state.opt+'&isRange=true'
    }    

    if (process.env.NODE_ENV == "development") {
      url  = './?startPage='+param
    } else{
      url = './pdf/v2/?startPage='+param
    }
    this.refs.iframe.loadUrl(url)
  }

  onExportExcelDetail(e) {
    const worksheet = XLSX.utils.table_to_book(document.getElementById(this.refTableDetailId));
    let wbout = XLSX.write(worksheet, { bookType: 'xlsx', bookSST: true, type: 'binary' });

    function s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
      return buf;
    }    
    let {type,opt} = this.state
    let fileName = 'รายงานงวดตั้งเบิกค้างรับ ลูกค้า '+(opt=='all'?'ทั้งหมด ':opt=='person'?'เจ้าของรถ(บุคคล) ':opt=='company'?'เจ้าของรถ(บริษัท) ':opt=='insurer'?'เจ้าของ(บริษัท) ':'')+'ประเภท '+(type=='wait_finance'?'ยอดรวมค้างตั้งเบิก':type=='wait_payment'?'ยอดรวมค้างรับ':'')+'.xlsx'
    FileSaver.saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), fileName)
    this.setState({showExport:false})
  }

  onPrintTableDetail(e) {
    let url = ''
    let param = 'PrintReportAccountReceiableDetail&customerType='+this.state.opt+'&type='+this.state.type+'&year='+this.state.year+'&month='+this.state.month+'&day='+this.state.day
    if (process.env.NODE_ENV == "development") {
      url  = './?startPage='+param
    } else{
      url = './pdf/v2/?startPage='+param
    }
    this.refs.iframe.loadUrl(url)
  }

  onStartDateRangeChange(time) {
    if (time!=''&&time!=undefined&&time!=null) {
      let _day = time.substr(0,2)
      let _month = time.substr(3,2)
      let _year = time.substr(6,10)
      this.setState({day:_day*1,month:_month,year:_year*1,isRange:false})
      this.loadData(_year,_month,_day,this.state.opt,this.state.opt)
    }
  }

  onEndDateRangeChange(time) {
    if (time!=''&&time!=undefined&&time!=null) {
      let {day,month,year} = this.state
      let _day = parseInt(time.substr(0,2))
      let _month = parseInt(time.substr(3,5))
      let _year = parseInt(time.substr(6,10))
      this.setState({isRange:true,dayRange:_day,monthRange:_month,yearRange:_year})
      year = year - 543
      _year = _year - 543
      let start = day+'/'+(month=='00'?'1':month)+'/'+year
      let end = _day+'/'+_month+'/'+_year
      this.loadDataRange(start,end,this.state.opt)
    }  
  }

  onRangeChange(fromDateString,toDateString,items) {
    let {day,month,year,dayRange,monthRange,yearRange} = this.state
    day = items.from.format('DD')*1
    month = items.from.format('MM')
    year = (items.from.format('YYYY')*1)+543
    dayRange = items.to.format('DD')*1
    monthRange = items.to.format('MM')
    yearRange = (items.to.format('YYYY')*1)+543
    this.setState({isRange:true,day:day,month:month,year:year,dayRange:dayRange,monthRange:monthRange,yearRange:yearRange})
    const start = day+'/'+month+'/'+items.from.format('YYYY')
    const end = dayRange+'/'+monthRange+'/'+items.to.format('YYYY')
    this.loadDataRange(start,end,this.state.opt)
  }

  renderWCalendar() {
    return(
      <div style={{display:'inline-flex'}}>
        <DatePicker 
                style={{display:'inline-block'}}
                height={'36px'}
                none={true}
                showIcon={true}
                showFooter={true}
                popPlacement='bottom'
                buddhistEra
                value={(this.state.day=='00'?momentHelper.getDay():this.state.day)+'/'+(this.state.month=='00'?WHOLE_YEAR:this.state.month)+'/'+this.state.year}
                onChange={this.onStartDateRangeChange.bind(this)}
                maxWidth={'100%'}
                onRangeChange={this.onRangeChange.bind(this)}
          />
          <DatePicker 
                style={{display:'inline-block'}}
                height={'36px'}
                none={true}
                showIcon={true}
                showFooter={true}
                popPlacement='bottom'
                buddhistEra
                value={(this.state.dayRange=='00'?momentHelper.getDay():this.state.dayRange)+'/'+(this.state.monthRange=='00'?WHOLE_YEAR:this.state.monthRange)+'/'+this.state.yearRange}
                onChange={this.onEndDateRangeChange.bind(this)}
                maxWidth={'100%'}
                onRangeChange={this.onRangeChange.bind(this)}
          />
      </div>
    )
  }

  renderToolbar() {
    return(
      <Form inline>
        <FormGroup style={{verticalAlign:'top'}}>
          <SelectDate
            wholeYear={true}
            year={this.state.year}
            month={this.state.month}
            day={this.state.day}
            onMonthChange={this.onMonthChange.bind(this)}
            onYearChange={this.onYearChange.bind(this)}
            onDayChange={this.onDayChange.bind(this)}
            dayWCalendar={true}
            renderWCalendar={this.renderWCalendar.bind(this)}
          />
        </FormGroup>  
        <div style={{ width: '150px', display: 'inline-block', marginLeft:'5px' }}>
          <Select
            clearable={false}
            name="form-field-name"
            value={this.state.opt}
            options={this.state.optList}
            onChange={this.onOptChange.bind(this)}
          />
        </div>
        <FormGroup style={{verticalAlign:'top',marginLeft:'5px',marginTop:'1.5px'}}>
          <PrintButtons
            onPrintTable={this.onPrintTable.bind(this)}
            onExportExcel={this.onExportExcel.bind(this)}
            marginLeft='0'
            width='auto'
          />
        </FormGroup>
      </Form>
    )
  }

  renderToolbarDetail() {
    return(
        <Form inline>
            <FormGroup style={{verticalAlign:'top',marginTop:'1.5px',marginBottom:'5px'}}>
                <PrintButtons
                    onPrintTable={this.onPrintTableDetail.bind(this)}
                    onExportExcel={this.onExportExcelDetail.bind(this)}
                    marginLeft='0'
                    width='auto'
                />
            </FormGroup>
        </Form>
    )    
  }

  renderPaging() {
    return (
      <div className="text-center pull-right">
        <Pagination
          prev
          next
          first
          last
          bsSize="medium"
          items={5}
          activePage={this.state.activePage}
          onSelect={this.onPageSelect.bind(this)} />
      </div>
    )
  }

  getStartDateRangeText() {
    let {day,month,year} = this.state
    let txtMonth = momentHelper.getMonthText(month.toString())
    return day*1+' '+ txtMonth +' '+ year
  }

  getEndDateRangeText() {
    let {dayRange,monthRange,yearRange} = this.state
    dayRange = dayRange==0?1:dayRange
    let txtMonth = momentHelper.getMonthText(monthRange.toString())
    return dayRange +' '+ txtMonth +' '+ yearRange
  }

  onRangeClearClick() {
    this.loadData(this.state.year,this.state.month,this.state.day,this.state.opt)
    this.setState({isRange:false,dayRange:momentHelper.getDay(),monthRange:this.state.month,yearRange:this.state.year})
  }

  renderDateRange() {
    let {isRange} = this.state
    if (isRange) {
      return(
        <div style={{marginBottom:'10px',display:'flex'}}>
          {this.getStartDateRangeText()} - {this.getEndDateRangeText()}&nbsp;<Button className='btn btn-xs' onClick={this.onRangeClearClick.bind(this)}><FontAwesome name='eraser' />&nbsp;ลบช่วงเวลา</Button>
        </div>
      )
    } else {
      return('')
    }  
  }

  render() {
    const reportName = 'รายงานงวดตั้งเบิกค้างรับ'
    const reportDateText = momentHelper.getMonthText(this.state.month) + " " + this.state.year
    const title = reportName + ' ' + reportDateText
    const {loading,showDetail} = this.state
    return (
      <Box loading={loading}>
        <Box.Header border={true}>          
          {this.props.renderMenu(this.state.isSubMenu,this.state.subMenu)}
        </Box.Header>
        <Box.Body>
          {showDetail?this.renderToolbarDetail():this.renderToolbar()}
          {!showDetail?this.renderDateRange():''}
          {showDetail?this.renderTableDetail():this.renderTable()}
          {/* this.renderPaging() */}
          <IframeModal ref='iframe' title={'พิมพ์เอกสาร'} />
        </Box.Body>
        {showDetail?
        <Box.Footer>
            <div className=" pull-right">
                <Button bsStyle='default' onClick={this.onTableDetailCloseClick.bind(this)}><FontAwesome name='table' />&nbsp;กลับหน้าตารางหลัก</Button>    
            </div>
        </Box.Footer>
        :''}
      </Box>
    )
  }
}

ReportAccountReceiable.defaultProps = {
  show : false
}

export default ReportAccountReceiable;


// WEBPACK FOOTER //
// ./src/view/report/finance/ReportAccountReceiable.js